// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-1dc25ev-0"
})(["min-width:", ";max-width:", ";height:", ";"], _ref => {
  let {
    $size
  } = _ref;
  return $size;
}, _ref2 => {
  let {
    $size
  } = _ref2;
  return $size;
}, _ref3 => {
  let {
    $size
  } = _ref3;
  return $size;
});
const Video = _ref4 => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref4;
  return /*#__PURE__*/_jsxs(SVG, {
    ...props,
    $size: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation',
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, " ", /*#__PURE__*/_jsx("path", {
      fill: color,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.956 5.752v11.783a.75.75 0 0 1-1.247.561l-5.026-4.454a.75.75 0 0 1-.252-.562l.003-2.191a.75.75 0 0 1 .213-.523l5.023-5.139a.75.75 0 0 1 1.286.525Zm-1.5 1.84-3.523 3.604-.002 1.547 3.525 3.125V7.592ZM2 5.752v11.783c0 .414.336.75.75.75h11a.75.75 0 0 0 .75-.75V5.752a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0-.75.75Zm1.5.75H13v10.283H3.5V6.502Z",
      children: " "
    })]
  });
};
Video.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,
  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,
  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Video;